<template lang="pug">
  v-container
    v-layout(justify-center)
      v-flex(xs8)
        v-layout
          v-flex(xs12)
            h1 Создание компании
            UploadImages(@set-files="setFiles")
        v-layout
          v-flex(xs12)
            h2 Добавить описание
            v-text-field(
              v-model="name"
              label="Название"
              solo)
            v-textarea(
              v-model="description"
              solo
              label="Описание компании")
        v-layout
          v-flex(xs12 d-flex justify-center)
            v-btn(large) Отмена
            v-btn(large color="info" @click="addCompany").ml-3 Создать
</template>
<script>
import axios from 'axios'

export default {
  components: {
    Header: () => import('../../components/Header'),
    UploadImages: () => import('../../components/common/UploadImages')
  },
  data: () => ({
    name: '',
    description: '',
    files: []
  }),
  methods: {
    setFiles(files) {
      this.files = files
    },
    uploadImages(media) {
      return axios({
        method: 'post',
        url: 'https://cdn.onoi.kg/api/upload/folder/',
        config: {
          headers: { 'Content-Type': 'multipart/form-data' }
        },
        data: media
      })
        .then(response => {
          return response.data
        })
        .catch(err => {
          return err
        })
    },
    addCompany() {
      const data = {
        name: this.name,
        description: this.description
      }
      this.$store.dispatch('ADD_COMPANY', { ...data }).then(id => {
        const media = new FormData()
        data.companyId = id
        media.append('id', id)
        this.files.map(file => {
          media.append('images', file)
        })
        this.uploadImages(media).then(result => {
          if (result.images.length) {
            data.photos = result.images
          }
          this.$store.dispatch('ADD_COMPANY', { ...data }).then(() => {
            this.$router.push('/')
          })
        })
      })
    }
  }
}
</script>
